export enum BigLogoType {
    DEFAULT = 'default',
    LOGIN = 'login',
}
